import { Button, Flex } from 'antd'
import Title from 'antd/es/typography/Title'
import { styled } from 'styled-components'

import { back, navigate } from '@redwoodjs/router'

import { useCurrentBreakpoint } from 'src/hooks/use-current-breakpoint'
import { useLightnessMode } from 'src/hooks/use-lightness-mode'

import TopBarTemplate from '../../components/Topbar/TopbarTemplate'
import { Icon, Link } from '../../govwell-ui'
import { useLaunchIntercom } from '../../hooks/use-launch-intercom'
import { TopbarPageLayoutContainer } from '../../layouts/TopbarLayout/TopbarLayout'
import { Logo, LogoColor } from '../svgs/Logo'

const Main = styled.main`
  height: 100%;
  flex: 1;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
`

interface Props {
  href?: string
}

export const ErrorPage = (props: Props) => {
  const { href } = props
  const { isSmallScreen } = useCurrentBreakpoint()

  const { launchIntercom } = useLaunchIntercom()
  const { isDarkMode } = useLightnessMode()

  return (
    <TopbarPageLayoutContainer>
      <TopBarTemplate
        title={null}
        image={<Logo color={isDarkMode ? LogoColor.White : LogoColor.Black} />}
        onClickImage={() => {
          if (href) {
            navigate(href)
            window?.location?.reload?.()
          } else {
            back()
          }
        }}
      />
      <Main>
        <Title
          level={3}
          style={{
            width: isSmallScreen() ? '80%' : '30%',
            textAlign: 'center',
          }}
        >
          Oops! A bug occurred. Chat with our Support Team now or email us at{' '}
          <Link externalHref="mailto:help@govwelltech.com">help@govwell.com</Link>.
        </Title>
        <Flex vertical={isSmallScreen()} gap="12px">
          <Button size="large" icon={<Icon.FaMessage />} onClick={launchIntercom}>
            Chat with us
          </Button>
          <Button
            icon={<Icon.FaRefresh />}
            size="large"
            type="primary"
            onClick={async () => {
              if (href) {
                navigate(href)
                window?.location?.reload?.()
              } else {
                window?.location?.reload?.()
              }
            }}
          >
            Refresh to continue
          </Button>
        </Flex>
      </Main>
    </TopbarPageLayoutContainer>
  )
}

export default ErrorPage
